import React, { useEffect, useRef, useState } from 'react';
import { GridColDef, GridRowId } from '@mui/x-data-grid';
import { AppBar, Box, Button, createTheme, Paper, Typography, useMediaQuery, useTheme } from '@mui/material';
import { useApi } from '../../../services/HttpService';
import ScrollableDataGrid from '../../../components/tables/ScrollableDataGrid';
import { GridApiCommunity } from '@mui/x-data-grid/internals';
import BaseModal from '../../../components/modals/BaseModal';
import { StickyAlert } from '../../../components/ui/StickyAlert';
import { highlightedGridColumns } from '../../../components/tables/BaseTable';
import { EnhancedTableToolbar } from '../../../components/tables/AdminTable';
import HardDeleteDialog from '../../../components/modals/dialog/HardDeleteDialog';
import { AppDeviceOverview } from './AppDeviceOverview';
import {newAppDevice, AppDevice, AppBase, AppDeviceMessage} from '../../../model/AppBase';
import  LeftSideMenu  from '../../../components/layouts/navigations/LeftSideMenu';
import { useNavigate } from 'react-router-dom';

const mainColumns: GridColDef[] = [
    { field: 'id', headerName: 'ID', width: 50 },
    { field: 'name', headerName: 'Name', width: 50},
    { field: 'vehicle_id', headerName: 'Vehicle', width: 90 },
    { field: 'company_id', headerName: 'Company', width: 90 },
    { field: 'app_version', headerName: 'App version', width: 200 },
    { field: 'os_name', headerName: 'Os name', width: 200 },
    { field: 'os_version', headerName: 'Os version', width: 200 },
    { field: 'device_model', headerName: 'Device model', width: 200 },
    { field: 'last_seen_at', headerName: 'Last seen at', width: 200 },
    { field: 'app_name', headerName: 'App name', width: 200 },
    { field: 'number_of_messages', headerName: 'Number of messages to send', width: 200 },
    { field: 'failed_to_get_messages', headerName: 'Failed Messages', width: 200 },
];

export const ManageAppDevices = () => {
  const [AppDevices, setAppDevices] = useState<AppDevice[]>([]);
  const [tabIndex, setTabIndex] = useState(0);
  const theme = useTheme();
  const { api, isLoading, error } = useApi();
  const { api: deleteApi, isLoading: deleteIsLoading, error: deleteError } = useApi();
  const { api: dataApi, error: dataError } = useApi();
  const [AppDevice, setAppDevice] = useState<AppDevice>(newAppDevice());
  const [filteredAppDevices, setFilteredAppDevices] = useState<AppDevice[]>([]);
  const [searchText, setSearchText] = useState("");
  const [selectedIds, setSelectedIds] = useState<readonly GridRowId[]>([]);
  const [openDelete, setOpenDelete] = useState(false);
  const [openEditAppDevice, setOpenEditAppDevice] = useState(false);
  const apiRef = useRef<GridApiCommunity>(null);
    const navigate = useNavigate();
  // const addMemberRef = useRef<MemberFormRef>(null);

  const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'));

  React.useEffect(() => {
    getData();
  }, []);

  const onItemChange = (changedItem: AppDevice) => {
    setAppDevices((prevProfiles) => {
      const index = prevProfiles.findIndex(u => u.id === changedItem.id);
      if (index > -1) {
        return prevProfiles.map((user, i) => (i === index ? changedItem : user));
      } else {
        return [...prevProfiles, changedItem];
      }
    });

    setAppDevice(changedItem);
    setSelectedIds([changedItem.id]);
  }
  
  const getData = () => {
    // api("manage/app/getAppDevices", "POST").then((res) => {
    //   if (res?.statusCode === 200) {
    //     setAppDevices(res.data);
    //   }
    // });

    api("/manage/app/getAppDevices", "POST", { search: "", limit: 0 }).then((res) => {
        if (res?.statusCode === 200) {
          setAppDevices(res.data);
        }
    });
  }

  useEffect(() => {
    handleSearch(searchText);
  }, [AppDevices]);

  const handleSearch = (searchText: string) => {
    const query = searchText.toLowerCase();
    setSearchText(query);

    const filteredData = AppDevices ? AppDevices.filter((row) =>
      mainColumns.some((column) => {

        // Use valueGetter if defined, otherwise use the field directly
        const value = column.valueGetter
          ? column.valueGetter(undefined as never, row, column, apiRef)
          : row[column.field];

        return String(value).toLowerCase().includes(query);
      })
    ) : [];

    setFilteredAppDevices(filteredData);
  };

  const getPageAppDevices = (page: number, pageSize: number) => {
    if (AppDevices.length === 0) {
      return [];
    }
    const sublist = AppDevices.slice(page * pageSize, (page + 1) * pageSize);
    console.log("returning members from index", page * pageSize, "-", (page + 1) * pageSize, "count", sublist.length)
    return sublist;
  }

  const handleRowSelectionModelChange = (ids: number[]) => {
    setSelectedIds(ids);

    if (ids.length > 0) {
      let selectedAppDevice = AppDevices.find(u => u.id === ids[0]);
      setAppDevice(selectedAppDevice);
    } else {
      setAppDevice(newAppDevice());
    }
  }

  const handleRowDoubleClick = (row) => {
    let ids = [row.id];
    handleRowSelectionModelChange(ids);
    setOpenEditAppDevice(true);
  }

  const handleDelete = (hardDelete: boolean) => {
    alert("delete not implemented");
  }

  
  //TODO: Check if Chat is activated on given App
  // useEffect(()=>{
  //   navigate("/app/device/AppSettings");
  // });


  return (
    <>
    <Box sx={{ width:'100%' , display: 'flex' }} >
       {/* Left Sidebar   */}
       <Box sx={{ width: '15%', minWidth: 200, borderRight: '1px solid #ddd', alignItems: 'left' }}>
         <LeftSideMenu
           items={[
             { name: 'Devices', link: '/app/device/ManageAppDevices', selected: true },
             { name: 'Push messages', link: '/app/device/ManageAppMessages', selected: false },
             { name: 'Chat', link: '/app/device/ManageAppChat', selected: false },
             { name: 'Content', link: '/app/device/ManageAppContent', selected: false },
             { name: 'Links', link: '/app/device/ManageAppLinks', selected: false },
             { name: 'Settings', link: '/app/device/AppSettings', selected: false },
           ]}
         />
       </Box>
        <Box sx={{ width: '85%' }}>
          <BaseModal
            open={openEditAppDevice}
            title={AppDevice.id > 0 ? "Edit Device" : "New Device"}
            onClose={() => { setOpenEditAppDevice(false) }}
            closeOnBackdropClick={false}
            showButtons={false}
          >
          <AppDeviceOverview onClose={() => setOpenEditAppDevice(false)} app={null} item={AppDevice} onItemChange={onItemChange}/>
          </BaseModal>
          <HardDeleteDialog
            open={openDelete}
            bodyText={`Er du sikker på at du vil slette ${AppDevice.name} ? Trykk på "SLETT" for å bekrefte.`}
            includeHardDelete={true}
            loading={deleteIsLoading}
            errorMessage={deleteError}
            onClose={() => setOpenDelete(false)}
            onConfirm={(hardDelete) => handleDelete(hardDelete)}
          />

          <StickyAlert message={error ? error : dataError ? dataError : null} severity="error" />

          <Box sx={{ m: 1, mt: 3, p: { xs: 1, md: 3 }, pt: 0}}>
          <Paper elevation={3} sx={{ borderRadius: "4px 4px 0 0" }}>
              <EnhancedTableToolbar
                title={""}
                numSelected={openEditAppDevice || selectedIds.length > 0 ? 1 : 0}
                selectTitle={AppDevice.id ? `${AppDevice.name}` : ""}
                onAdd={() => setOpenEditAppDevice(true)}
                onEdit={() => setOpenEditAppDevice(true)}
                onCancel={() => { setOpenEditAppDevice(false); setSelectedIds([]); setAppDevice(newAppDevice()) }}
                onDelete={() => setOpenDelete(true)}
                onSearch={handleSearch}
                onRefresh={getData}
              />
            </Paper>
              <ScrollableDataGrid
                height={500}
                rows={filteredAppDevices}
                columns={mainColumns ? highlightedGridColumns(mainColumns, searchText, apiRef) : []}
                loading={isLoading}
                onPageRequest={getPageAppDevices}
                checkboxSelection
                disableMultipleRowSelection
                onRowSelectionModelChange={(ids) => handleRowSelectionModelChange(ids)}
                onRowDoubleClick={(row) => handleRowDoubleClick(row)}
                rowSelectionModel={selectedIds}
                keepNonExistentRowsSelected={true}
              />
          </Box>
        </Box>
    </Box>
   </>
  )
}